
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { useInView } from "../../hooks";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { IProfileWebsite, ITeamHistory, Status } from "../../../../../services";
import { activeMedia, isPageVisible, pagePath } from "../../helpers";

export interface BioProps {
    basePath: string;
    website: IProfileWebsite;
    teamHistories?: ITeamHistory[];
}

function Bio({ website, basePath, teamHistories = [] }: BioProps) {

    const [ref, inView] = useInView();
    const labels = i18nManager.Labels;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const image = activeMedia(website, "HALF_BODY") ?? activeMedia(website, "BANNER") ?? activeMedia(website, "PASSPORT");
    const currentTeam = teamHistories.find((t) => t.status === Status.ACTIVE);
    const timeline = [...teamHistories].sort((a, b) => new Date(a.join_date).getTime() - new Date(b.join_date).getTime());
    const facts: [string, React.ReactNode][] = ([
        [labels.facts.username, `@${website.member.username}`],
        [labels.facts.age, website.member.age],
        [labels.facts.country, website.member.country_code ? globalI18nManager.queryCountryCurrency(website.member.country_code, "country_code", "country_name") : null],
        [labels.facts.current_team, currentTeam?.name],
        [labels.facts.teams, teamHistories.length || null],
        [labels.facts.member_since, website.created_at ? new Date(website.created_at).getFullYear() : null],
    ] as [string, React.ReactNode][]).filter(([_, v]) => v !== null && v !== undefined && v !== "");
    const badgeStat = website.extra_data?.stats ? Object.entries(website.extra_data.stats)[0] : undefined;

    return (<section className={Classname.build(styles["section"], styles["section-alt"])}>
        <div className={styles["container"]}>
            <div ref={ref} className={styles["bio-grid"]} style={image ? undefined : { gridTemplateColumns: "1fr" }}>
                {image && (<div className={Classname.build(styles["bio-img-col"], styles["reveal-left"], { [styles["in-view"]]: inView })}>
                    <div className={styles["bio-img-wrap"]}>
                        <img src={image} alt={website.display_name} />
                        <div className={styles["bio-img-veil"]} />
                        {badgeStat && (<div className={styles["bio-img-badge"]}>
                            <div className={styles["bio-img-badge-num"]}>{badgeStat[1] as React.ReactNode}</div>
                            <div className={styles["bio-img-badge-lbl"]}>{badgeStat[0].replaceAll("_", " ")}</div>
                        </div>)}
                    </div>
                    <div className={styles["bio-img-frame"]} />
                </div>)}

                <div className={Classname.build(styles["bio-content"], styles["reveal-right"], { [styles["in-view"]]: inView })}>
                    <div className={styles["eyebrow"]}>{labels.home.bio_eyebrow}</div>
                    <h2 className={styles["bio-title"]}>{labels.home.bio_title}<br />{labels.home.bio_title_em}</h2>
                    {website.profile_detail && (<p className={styles["bio-text"]}>{website.profile_detail}</p>)}
                    {facts.length > 0 && (<div className={styles["facts"]}>
                        {facts.map(([k, v]) => (<div key={k} className={styles["fact"]}>
                            <div className={styles["fact-key"]}>{k}</div>
                            <div className={styles["fact-val"]}>{v}</div>
                        </div>))}
                    </div>)}
                    {isPageVisible(website, "TEAM_HISTORY") && (<div>
                        <Btn to={{ pathname: pagePath(basePath, "TEAM_HISTORY"), search: searchParams.toString() }}>{labels.home.view_teams} <i className="fa fa-arrow-right" /></Btn>
                    </div>)}
                </div>
            </div>

            {timeline.length > 0 && (<div className={styles["timeline-wrap"]}>
                <div className={styles["eyebrow"]}>{labels.home.career_journey}</div>
                <div className={styles["timeline"]}>
                    {timeline.map((t, i) => (<div key={t.external_id} className={styles["tl-item"]}>
                        {i < timeline.length - 1 && (<div className={styles["tl-line"]} />)}
                        <div className={styles["tl-dot"]}>{t.logo_url ? (<img src={t.logo_url} alt={t.name} />) : (<i className="fa fa-futbol" /> )}</div>
                        <div className={styles["tl-year"]}>{new Date(t.join_date).getFullYear()}</div>
                        <div className={styles["tl-event"]}>{t.name}</div>
                    </div>))}
                </div>
            </div>)}
        </div>
    </section>);
}

export default Bio;
